// ============================================================================
// MediaIA — MS-10
// ----------------------------------------------------------------------------
// Página única que consolida as 3 superfícies de mídia da Syra:
//   • Histórico   → MediaHistory  (timeline de mídias processadas)
//   • Saúde       → MediaInsights (métricas/qualidade do pipeline multimodal)
//   • Pipeline    → CortexMultimodal (configuração e nós multimodais)
//
// Estratégia: NÃO duplicar lógica. Cada tab apenas renderiza o componente
// existente. A tab ativa é persistida na URL via ?tab= para deep-link.
// ============================================================================

import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MediaHistory from "@/pages/MediaHistory";
import MediaInsights from "@/pages/admin/MediaInsights";
import CortexMultimodal from "@/pages/CortexMultimodal";
import MediaHallucinations from "@/pages/admin/MediaHallucinations";

const VALID_TABS = ["historico", "saude", "pipeline", "alucinacoes"] as const;
type Tab = (typeof VALID_TABS)[number];

export default function MediaIA() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const active: Tab = (VALID_TABS as readonly string[]).includes(raw ?? "")
    ? (raw as Tab)
    : "historico";

  const setTab = (t: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", t);
    setParams(next, { replace: true });
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">Media IA</h1>
        <p className="text-muted-foreground mt-1">
          Histórico, saúde e pipeline multimodal da Syra em um só lugar.
        </p>
      </header>

      <Tabs value={active} onValueChange={setTab} className="w-full">
        <TabsList>
          <TabsTrigger value="historico">Histórico</TabsTrigger>
          <TabsTrigger value="saude">Saúde</TabsTrigger>
          <TabsTrigger value="pipeline">Pipeline</TabsTrigger>
          <TabsTrigger value="alucinacoes">Alucinações</TabsTrigger>
        </TabsList>

        <TabsContent value="historico" className="mt-4">
          <MediaHistory />
        </TabsContent>
        <TabsContent value="saude" className="mt-4">
          <MediaInsights />
        </TabsContent>
        <TabsContent value="pipeline" className="mt-4">
          <CortexMultimodal />
        </TabsContent>
        <TabsContent value="alucinacoes" className="mt-4">
          <MediaHallucinations />
        </TabsContent>
      </Tabs>
    </div>
  );
}
